/*
 * @Author: seven.zhang 
 * @Date: 2019-02-13 14:36:17 
 * @Last Modified by: seven.zhang
 * @Last Modified time: 2019-09-02 13:47:55
 */


import citygeo from "@/config/citygeo";
import chartSet from "@/config/chartSet";
import Util from '@/utils/Util';
// let dpr = window.devicePixelRatio; //获取设备dpr
let dpr = Util.setDpr(); //获取设备dpr
// console.log(dpr)

export default {
    /**
     * 饼图
     * @param {*} obj 
     */
    getPieEchart(obj) {
        let color = ['#FFDA3A', '#FF9977', '#3577FD', '#00A4DF', '#00C8ED', '#00FFC0'];
        return {
            color: color,
            title: {
                ...obj.title
            },
            tooltip: {
                trigger: 'item',
                formatter: "{a} <br/>{b} : {c}",
                ...obj.tooltip
            },
            series: [{
                name: '',
                type: 'pie',
                // minAngle: 10,//最小的扇区角度（0 ~ 360），用于防止某个值过小导致扇区太小影响交互
                avoidLabelOverlap: true, //是否启用防止标签重叠策略
                center: ['50%', '50%'],
                radius: ['25%', '55%'],
                label: {
                    normal: {
                        show: true,
                        // formatter: [
                        //     '{value|'+Util.keepPoint('{d}',2)+'}{unit|%}',
                        //     '{label|{b}}',
                        //     ''
                        // ].join('\n'),
                        formatter(param){
                            return [
                                    '{value|'+Util.keepPoint(param.percent,1)+'}{unit|%}',
                                    '{label|'+param.name+'}',
                                    ''
                                ].join('\n')
                        },
                        position: 'outside',
                        fontSize: 12 * dpr,
                        rich: {
                            value: {
                                fontSize: 18 * dpr,
                                fontWeight:'bold'
                            },
                            unit: {
                                fontSize: 12 * dpr,
                            },
                            label: {
                                fontSize: 12 * dpr,
                                color: '#fff'
                            }
                        }
                    },
                },
                labelLine: {
                    length: 17 * dpr, //视觉引导项第一段的长度
                    length2: 4 * dpr //视觉引导项第二段的长度
                },
                lineStyle: {
                    width: 2 * dpr,
                },
                data: [],
                ...obj.series
            }]
        }
    },
    /**
     * 折线图
     * @param {*} obj 
     * @param {obj.yAxisNum} 若不设置，表示只有一个y轴，设置为2，下面已有默认设置，若不用默认设置，可传入obj.yAxis
     */
    getBaseEchart(obj) { 
        let yAxis = [];
        let baselist = {
            type: 'value',
            splitLine: {
                show: false
            },
            axisLine: {
                show: false
            },
            axisLabel: {
                show: false
            },
            axisTick: {
                show: false
            },
        }
        // 设置有Y轴
        if(obj.yAxisNum&&obj.yAxisNum==2){
            [1,2].forEach((item,index)=>{
                let list = baselist
                if(obj.yAxis&&obj.yAxis.length){
                    list = {...baselist,...obj.yAxis[index]}
                }
                yAxis.push(list)
            })
        }else{
            yAxis=[Object.assign(baselist,obj.yAxis[0])]
        }
        return {
            color: obj.color ? obj.color : [],
            title: {
                ...obj.title
            },
            tooltip: {
                trigger: 'axis',
                axisPointer: {
                    type: 'line',
                    label: {
                        backgroundColor: '#6a7985'
                    }
                },
                // formatter: '{b}<br />{a0}: {c0}<br />{a1}: {c1}',
                formatter: function(param) {
                    // console.log(param,obj)
                    let title = `<span style="opacity:0">${param[0].marker}</span><span class="fs_12 c_fff">${param[0].name}</span>`
                    let data=[]
                    param.forEach((item,index)=>{
                        let list = item.marker+`<span class="fs_12 c_fff">${item.seriesName}</span>
                                                <span class="fs_16 fw_b c_fff">${Util.formatNum(item.value)}</span>
                                                <span class="fs_12 c_fff"">${obj.unit?obj.unit[index]:''}</span>`
                        data.push(list)
                    })
                    
                    return data.join('<br />') + '<br />'+ title
                        
                },
                ...obj.tooltip
            },
            legend: {
                show: false,
                bottom: '10%',
                textStyle: {
                    fontSize: 12 * dpr,
                },
                ...obj.legend
            },
            grid: {
                top: '8%',
                left: '1%',
                right: '1%',
                bottom: '8%',
                containLabel: true,
                ...obj.grid
            },
            xAxis: [{
                type: 'category',
                boundaryGap: false,
                axisLine: { //坐标轴轴线相关设置。数学上的x轴
                    show: true,
                    lineStyle: {
                        color: '#E7E9ED'
                    },
                },
                axisLabel: { //坐标轴刻度标签的相关设置
                    textStyle: {
                        color: '#ADAFB2',
                        margin: 15,
                        fontSize: 12 * dpr,
                    },
                },
                axisTick: {
                    show: true,
                    inside: true,
                    alignWithLabel: true,//类目轴中在 boundaryGap 为 true 的时候有效，可以保证刻度线和标签对齐
                    interval:0,
                    lineStyle:{
                        type:'dashed'
                    }
                },
                data: [],
                ...obj.xAxis
            }],
            yAxis: yAxis,
            series: obj.series
        }
    },
    /**
     * 阶梯柱状图
     * @param {*} obj 
     */
    getLadderBarEchart(obj) {
        return {
            tooltip: {
                trigger: 'item',
                // formatter: "{b}: {c}"
                formatter: function(param) {
                    // console.log(param)
                    let title = `<span class="fs_16 c_fff">${param.name}</span>`
                    let list1 = `<span class="fs_12 c_fff">${param.seriesName}：</span>
                                <span class="fs_16 c_fff">
                                    ${Util.formatNum(param.value)}
                                </span>
                                <span class="fs_12 c_fff">㎡</span>`
                    let list2 = `<span class="fs_12 c_fff">平均楼板价：</span>
                                <span class="fs_16 c_fff">
                                    ${Util.formatNum(obj[param.dataIndex].BlockPrice)}
                                </span>
                                <span class="fs_12 c_fff">元/㎡</span>`
                    return param.marker + title + '<br />'
                        + list1 + '<br />'
                        + list2
                        
                },
            },
            grid: {
                top: '8%',
                left: '6%',
                right: '6%',
                bottom: '15%',
                // containLabel: true,
            },
            xAxis: [{
                type: 'category',
                data: obj.map(e => {
                        return e.CityCaption 
                    }),
                axisLabel: { //坐标轴刻度标签的相关设置
                    show: true,
                    textStyle: {
                        color: '#FFF',
                        margin: 15,
                        fontSize: 12 * dpr,
                    },
                },
            }],
            yAxis: [{
                type: 'value',
                show: false
            }],
            series: [{
                name: '出让面积',
                type: 'bar',
                barGap: 0.1,
                barCategoryGap: 0.01,
                itemStyle: {
                    normal: {
                        color: function (params) {
                            // build a color map as your need.
                            var colorList = [
                                '#FF923D', '#F19B25', '#F1B100', '#F1C600', '#D3C12C',
                                '#B6BB52', '#96B670', '#71AB87', '#51ABA4', '#1AA5BD'
                            ];
                            return colorList[params.dataIndex]
                        },
                        shadowBlur: 80,
                        shadowColor: 'rgba(0, 0, 0, 0.5)'
                    }
                },
                data: obj.map(e => {
                            return Number(e.Area)
                        }),
            }]
        }
    },
    /**
     * 嵌套环形图 //房企全装修交付覆盖率
     * @param {*} obj 
     */
    getNestingPieEchart(obj) {
        let placeHolderStyle = {
            normal: {
                color: '#213748',
                opacity: 1
            },
            emphasis: {
                color: '#213748',
                opacity: 1
            }
        }
        let series = [];
        if(obj&&obj.length){
            obj.forEach((item,index)=>{
                let list = {
                    name: item.sCompany,
                    type: 'pie',
                    center: ['40%', '50%'],
                    radius: chartSet.deliveryCoverSet.radius[index],
                    label: false,
                    avoidLabelOverlap: true,
                    startAngle: 90,
                    clockWise: true, //顺时加载
                    hoverAnimation: true,
                    hoverOffset: 3,
                    data: [
                        {
                            value: item.iDecorateCnt,
                            name: '全装修个数',
                            // label: {
                            //     show: true,
                            //     position: 'outside',
                            //     color: '#fff',
                            //     fontSize: 12 * dpr,
                            // },
                            // labelLine: {
                            //     show: true,
                            //     length: 20 * dpr,
                            //     lineStyle: {
                            //         width: 2 * dpr
                            //     }
                            // },
                            itemStyle: {
                                color: { // 完成的圆环的颜色
                                    colorStops: [{
                                        offset: 0,
                                        color: chartSet.deliveryCoverSet.colorRange[index][0] // 0% 处的颜色
                                    }, {
                                        offset: 1,
                                        color: chartSet.deliveryCoverSet.colorRange[index][1] // 100% 处的颜色
                                    }]
                                }
                            }
                        },
                        {
                            value: item.iTotalCnt-item.iDecorateCnt,
                            hoverAnimation: false, //鼠标移入变大
                            itemStyle: placeHolderStyle
                        }

                    ]
                }
                series.push(list)
            })
        }

        return {
            tooltip: {
                trigger: 'item',
                formatter: "{a} : {c} ({d}%)"
            },
            series: series
        }
    },


    /**
     * 装修系统页 全装修趋势饼图
     * @param {*} obj 
     */
    getTrendPieEchart(obj) {
        let series = [{
                name: '',
                type: 'pie',
                center: ['50%', '45%'],
                radius: ['47%', '60%'],
                hoverAnimation: false,
                label: {
                    normal: {
                        show: true,
                        // formatter: [
                        //     '{value|{d}}{unit|%}',
                        //     '{label|{b}}',
                        //     ''
                        // ].join('\n'),
                        formatter(param){
                            return [
                                    '{value|'+Util.keepPoint(param.percent,1)+'}{unit|%}',
                                    '{label|'+param.name+'}',
                                    ''
                                ].join('\n')
                        },
                        position: 'outside',
                        fontSize: 12 * dpr,
                        rich: {
                            value: {
                                fontSize: 18 * dpr,
                            },
                            unit: {
                                fontSize: 12 * dpr,
                            },
                            label: {
                                fontSize: 12 * dpr,
                                color: '#fff'
                            }
                        }
                    },
                },
                labelLine: {
                    length: 8 * dpr, //视觉引导项第一段的长度
                    length2: 6 * dpr //视觉引导项第二段的长度
                },
                lineStyle: {
                    width: 2 * dpr,
                },
                data: [],
                ...obj.series
            },

        ]
        let circle = {
            name: '',
            type: 'pie',
            center: ['50%', '45%'],
            radius: ['42%', '43%'],
            hoverAnimation: false,
            label: {
                show: false
            },
            data: [{
                value: 36,
                name: '全装修'
            }, ],
        }
        if (obj.hasCircle) {
            series.push(circle)
        }
        return {
            color: obj.color,
            title: [{
                    text: obj.series.name,
                    textStyle: {
                        color: '#FFFFFF',
                        align: 'center',
                        fontSize: 14 * dpr,
                    },
                    textAlign: 'center',
                    left: '49%',
                    bottom: '2%',
                },
                ...obj.title
            ],
            tooltip: {
                show:false,
                trigger: 'item',
                formatter: "{a} <br/>{b} : {c}",
                ...obj.tooltip
            },
            series: series
        }
    },

    /**
     * 水滴图
     * @param {*} obj 
     */
    getDropEchart(obj) {
        return {
            title:{
                text:`{num|`+obj.iTotal+`}`+`{txt| 家已合作}`,
                textStyle:{
                    color:'#FFFFFF',
                    align:'center',
                    fontSize:14*dpr,
                    rich:{
                        num:{
                            fontSize:20*dpr,
                            color:'#00BBFF',
                        },
                        txt:{
                            fontSize:14*dpr,
                            color:'#fff',
                        }
                    }
                },
                textAlign:'center',
                left:'49%',
                bottom:'0',
            },
            series: [{
                type: 'liquidFill',
                waveAnimation: false,
                data: [obj.iRate,obj.iRate-(obj.iRate/5),obj.iRate-(obj.iRate/5)*2,obj.iRate-(obj.iRate/5)*3],
                center: ['50%', '45%'],
                radius: '75%',
                outline: {
                    borderDistance: 3*dpr,
                    itemStyle: {
                        borderWidth: 3*dpr,
                        borderColor: '#0D459A',
                        shadowBlur: 1*dpr,
                        shadowColor: '#fff'
                    }
                },
                backgroundStyle: {
                    borderWidth: 2*dpr,
                    // borderColor: 'rgb(255,0,255,0.9)',
                    color: '#21294E'
                },
                label: {
                    // formatter: '{d}\n已合作',
                    formatter: function(param) {
                        return `{value|`+(param.value*100).toFixed(2)+`}`+`{unit|%}` + '\n'
                            + `{txt|已合作}`
                            
                    },
                    rich:{
                        value:{
                            fontWeight:'bold',
                            fontSize:20*dpr,
                            color:'#fefefe'
                        },
                        unit:{
                            fontSize:16*dpr,
                            color:'#fefefe'
                        },
                        txt:{
                            fontSize:14*dpr,
                            color:'#fff'
                        }
                    },
                    color:'#fff',
                    // backgroundColor:'#21294E',
                    fontSize: 22*dpr
                }
            }]
        }
    },

    getMapBarEchart(data,max = 200,min = 0 ) {
        let convertData = function(data) {
            var res = [];
            for (var i = 0; i < data.length; i++) {
                var geoCoord = citygeo[data[i].name];
                if (geoCoord) {
                    res.push({
                        name: data[i].name,
                        value: geoCoord.concat(data[i].value)
                    });
                }
            }
            return res;
        };
        let _data = convertData(data);
        return {
            tooltip: {
                show: true
            },
            tooltip: {
                show: true,
                formatter:(params)=>{
                    let data = params.name + ":" + params.value[2] ;
                    return data;
                }
            },
            visualMap: [{
                type: 'continuous',
                seriesIndex: 0,
                text: ['bar3D'],
                calculable: true,
                min: min,
                max: max,
                inRange: {
                    color:['#91c660', '#7789a8', '#ed713b'] 
                },
                show:false
            }],
            geo3D: {
                map: 'china',
                left:-50,
                top:-50,
                right:-50,
                bottom:-50,
                roam: true,
                itemStyle: {
                    color: '#1d5e98',
                    opacity: 1,
                    borderWidth: 0.4,
                    borderColor: '#000'
                },
                label: {
                    show: false,
                    textStyle: {
                        color: '#000', //地图初始化区域字体颜色
                        fontSize: 8,
                        opacity: 1,
                        backgroundColor: 'rgba(0,23,11,0)'
                    },
                },
                emphasis: { //当鼠标放上去  地区区域是否显示名称
                    label: {
                        show: false,
                        textStyle: {
                            color: '#000',
                            fontSize: 3,
                            backgroundColor: 'rgba(0,23,11,0)'
                        }
                    }
                },
                //shading: 'lambert',
                light: { //光照阴影
                    main: {
                        color: '#fff', //光照颜色
                        intensity: 1.2, //光照强度
                        //shadowQuality: 'high', //阴影亮度
                        shadow: false, //是否显示阴影
                        alpha: 55,
                        beta: 10

                    },
                    ambient: {
                        intensity: 0.3
                    }
                }
            },
            series: [
                //柱状图
                {
                    name: 'bar3D',
                    type: "bar3D",
                    coordinateSystem: 'geo3D',
                    barSize: 1, //柱子粗细
                    shading: 'lambert',
                    opacity: 1,
                    bevelSize: 0.3,
                    label: {
                        show: false,
                        formatter: '{b}'
                    },
                    data: _data,
                }
            ]
        };
    }
}